var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"key-value-unit"},[_c('p',[_vm._v(_vm._s(_vm.title)+"：")]),_c('p',[_vm._v(_vm._s(_vm.value))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }